import Flickity from 'flickity';

// Below this width we leave the carousel as-is (mobile keeps its 2-up + peek layout).
const CENTER_MIN_WIDTH = 768;

// When there aren't enough slides to fill the row, Flickity left-aligns the cells
// (data-align "left"), leaving an awkward gap on the right. Measure the cells against the
// viewport and toggle `is-centered` so the CSS lays them out as a centred flex row instead —
// keeping each slide's original width + padding (so the gap between slides is unchanged).
const centerIfFits = (sliderEl: HTMLElement) => {
  const viewport = sliderEl.querySelector<HTMLElement>('.flickity-viewport');
  const cells = Array.from(sliderEl.querySelectorAll<HTMLElement>('.js-slide'));
  if (!viewport || !cells.length) return;
  const total = cells.reduce((sum, cell) => sum + cell.getBoundingClientRect().width, 0);
  // +1px tolerance for sub-pixel rounding.
  const fits = window.innerWidth >= CENTER_MIN_WIDTH && total <= viewport.clientWidth + 1;
  sliderEl.classList.toggle('is-centered', fits);
};

// The carousels themselves are initialised by the shared slider.ts (.js-slider) on
// DOMContentLoaded; run on the next frame so the Flickity viewport/cells exist before we
// measure.
document.addEventListener('DOMContentLoaded', () => {
  const sliders = Array.from(document.querySelectorAll<HTMLElement>('.slider-cc__slider'));
  if (!sliders.length) return;

  requestAnimationFrame(() => {
    sliders.forEach((sliderEl) => {
      // Drop any override first so Flickity re-measures in its own (absolute) layout.
      sliderEl.classList.remove('is-centered');
      const flkty = Flickity.data(sliderEl);
      flkty?.resize();
      centerIfFits(sliderEl);
    });
  });

  // Re-evaluate on resize (a width change can flip whether the slides fit).
  let raf = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      sliders.forEach((sliderEl) => {
        sliderEl.classList.remove('is-centered');
        const flkty = Flickity.data(sliderEl);
        flkty?.resize();
        centerIfFits(sliderEl);
      });
    });
  });
});
